module.exports = __webpack_public_path__ + "static/ChestnutHouse-bf18c07576124a1ee4b247bfd849bb59.jpg";